export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.proloadsolutions.com';

console.log("API_BASE_URL:", API_BASE_URL);

export const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'PROD';
export const GIT_SHA  = process.env.REACT_APP_GIT_SHA || 'unknown';